import type { FaireProductEntity } from "../../entity_types/product";

export const p_ttx5spvdta: FaireProductEntity = {
  token: "p_ttx5spvdta",
  type: "product",
  name: "Crushing It Notepad",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/17bb9bf296a7e4e49999b1f299130b51e266ab21df9efbf97fd329c946da1b4d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1b9bcecf3a5a56c7f8061cfdbcd085e96291481adaa342389fa8bd12ccea2284.jpeg",
  ],
  priceDollars: 9,
  description:
    "Who doesn't love a fresh, crisp and clean new notepad?! It's such a hopeful item. Just think of all you will go through together! \n\nAt E. Frances, we want each page to bring joy to your list-making, doodling and note-taking.",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:40.457Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
